/**
 * The "URL under test" a task page is reporting against — the deployed app URL the QA ran on.
 * Pages assemble candidates in priority order (e.g. a version's deployed_url, then the project's
 * static target_url, then its entrypoint) and this returns the first non-empty one, or null when
 * none is known so the caller can omit the indicator entirely.
 */
export function pickTargetUrl(...candidates: Array<string | null | undefined>): string | null {
  for (const candidate of candidates) {
    const trimmed = candidate?.trim()
    if (trimmed) return trimmed
  }
  return null
}
